// eslint-disable-next-line no-shadow
export enum CandidateApproval {
  APPROVED = 'APPROVED',
  DISAPPROVED = 'DISAPPROVED',
}
